import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
} from "react-bootstrap-table2-paginator";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { FaPlay, FaPause, FaClock, FaEye } from "react-icons/fa";
import './UsersAnalytics.css'
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import axios from "axios";
import { getItemToken } from "../../../Utils/localStorageUtils";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { statusActiveFormatter } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import ApexAreaChart from "./Chart/ApexAreaChart";
import { IconAdmin, IconFilter, IconRegister, IconSubscriber } from "../../../Assets/MyIcons";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import useTablePage from "../../../components/CommonComponents/useTablePage";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import Select from "react-select";
import ApexUserAreaChart from "./Chart/ApexUserAreaChart";
import { Modal, Button, Table, Spinner } from "react-bootstrap";

const UsersAnalytics = () => {

  const userAccessToken = getItemToken('access_token');

  const [filteredData, setFilteredData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [total, setTotal] = useState('');
  const { fetchRequest } = useMyContext();
  const [searchText, setSearchText] = useState('');
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })

  const [defaultData, setDefaultData] = useState({
    roles: [],
    filterTypes: [],
    totalPPVUser: 0,
    totalAdmin: 0,
    totalRegister: 0,
    totalSubscriber: 0
  })
  const [chartData, setChartData] = useState({
    categories: [],
    series: [
      {
        name: "USERS",
        data: []
      }
    ]
  });

  // Player Analytics Integration
  const [playerAnalytics, setPlayerAnalytics] = useState({
    totalSessions: 0,
    totalWatchHours: 0,
    playCount: 0,
    pauseCount: 0
  });

  // Watch History Modal State
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [watchHistory, setWatchHistory] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalSearchText, setModalSearchText] = useState("");

  // API Configuration for Player Analytics
  const analyticsEndpoint = `${process.env.REACT_APP_Baseurl}/analytics/player`;
  const apiKey = process.env.REACT_APP_ANALYTICS_API_KEY || 'fa-demo-2025-12345678';
  const tenantId = localStorage.getItem('tenant_id');
  const [editUser, setEditUser] = useState({
    role: "",
    startDate: '',
    endDate: '',
    filterType: "",
  });

  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [loading, setLoading] = useState(false);

  const roleRef = useRef()
  const startDateRef = useRef()
  const endDateRef = useRef()
  const filterTypeRef = useRef()

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const dateOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };

    const timeOptions = {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    };

    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    return (
      <>
        <div>{formattedDate}</div>
        <div className='userDateTime'>{formattedTime}</div>
      </>
    );
  }

  const userFormatter = (data, row) => {
    const formattedDate = formatDate(row?.created_at);
    return (
      <div className="d-flex justify-content-between gap-3 align-items-center">
        {/* <img key={row?.user_avatar} src={row.user_avatar} alt="Avatar" className="userProfileImageSize rounded-circle object-fit-cover" /> */}
        <div className="rightUserTitle">
          <p className="userNameProfile text-break">{data || "-"}</p>
          <span className="userDateText">{formattedDate}</span>
        </div>
      </div>
    );
  };

  const fallbackFormatter = (cell) => (cell ? cell : "-");
  const fallbackproviderFormatter = (cell) => (cell ? cell : "Manual");


  const columns = [
    // {
    //   dataField: "sno",
    //   text: "S.No",
    //   isDummyField: true,
    //   formatter: (cell, row, rowIndex) => rowIndex + 1,
    //   headerStyle: { width: "80px", textAlign: "center" },
    //   style: { textAlign: "center" },
    //   colStyle: "text-nowrap",
    // },
    {
      dataField: "id",
      text: "User Id",
      headerClasses: "text-center",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "name",
      text: "Username",
      formatter: userFormatter,
      classes: "userDesignBox",
      headerClasses: "userDesignBox",
      colStyle: "text-nowrap",
    },
    {
      dataField: "email",
      text: "Email",
      headerClasses: "userAnalyticsBox",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "mobile",
      text: "Mobile",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "provider",
      text: "Login Via",
      formatter: fallbackproviderFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "role",
      text: "Role",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "country",
      text: "Country",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "state",
      text: "State",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "city",
      text: "City",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "DOB",
      text: "DOB",
      formatter: fallbackFormatter,
      colStyle: "text-nowrap",
    },
    {
      dataField: "watch_hours",
      text: "Watch Hours",
      formatter: (cell) => cell || "00:00:00",
      colStyle: "text-nowrap",
    },
    // {
    //   dataField: "subscription_display_status",
    //   text: "Subscription Status",
    //   formatter: (cell) => {
    //     let badgeClass = "badge bg-secondary";
    //     if (cell === 'Subscribed') badgeClass = "badge bg-success";
    //     if (cell === 'Canceled') badgeClass = "badge bg-danger";
    //     return <span className={badgeClass}>{cell || "Register"}</span>;
    //   },
    //   colStyle: "text-nowrap",
    // },
    {
      dataField: "active",
      text: "Status",
      formatter: (cell, row) => statusActiveFormatter(cell, row),
      colStyle: "text-nowrap",
    },
    {
      dataField: "action",
      text: "Action",
      isDummyField: true,
      formatter: (cell, row) => (
        <button
          className="btn btn-sm btn-outline-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
          onClick={() => handleShowHistory(row)}
          title="View Watch History"
        >
          <FaEye size={16} />
        </button>
      ),
      headerStyle: { width: "100px", textAlign: "center" },
      style: { textAlign: "center" },
    },
  ];


  const handleFilterChange = (data) => {
    setFilteredData(data);
  };

  const handleShowHistory = async (user) => {
    setSelectedUser(user);
    setShowHistoryModal(true);
    setModalLoading(true);
    setWatchHistory([]);
    setModalSearchText("");

    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/analytics/player/user-watch-history`, {
        params: { userId: user.id },
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      if (response.data && response.data.status) {
        setWatchHistory(response.data.items);
      }
    } catch (error) {
      console.error("Error fetching watch history:", error);
    } finally {
      setModalLoading(false);
    }
  };

  const handleReload = () => {
    setWithoutRefresh(!withOutRefresh);
    setApiData([])
    setFilteredData([])
    setEditUser((prev) => ({
      ...prev,
      role: "",
      startDate: "",
      endDate: "",
      filterType: "",
    }))
  }

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;
    if (name === 'filterType') {
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        startDate: null,
        endDate: null
      }));
      if (!editUser?.role) {
        roleRef.current?.focus()
      }
    }
    if (name === "startDate" || name == "endDate") {
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        filterType: null,
      }));
      if (editUser?.startDate && !editUser?.endDate) {
        endDateRef.current.focus();
      } else if (editUser?.endDate && !editUser?.startDate) {
        startDateRef.current.focus();
      } else if (!editUser?.role) {
        roleRef.current?.focus();
      }
    }
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));
  };

  const fetchData = async () => {
    setLoading(true)
    try {

      const response = await fetchRequest({
        method: "GET",
        url: `${process.env.REACT_APP_Baseurl}/admin/users-analytics`,
        params: {
          limit, page, role: editUser?.role, filter_type: editUser?.filterType, start_date: editUser?.startDate, end_date: editUser?.endDate, search: searchText,
        },
        data: {},
      });

      const userData = response?.Users;
      const paginationData = response?.pagination;

      const FilterHelp = userData.map((item) => {
        const Role =
          item?.role == 1
            ? "Admin"
            : item?.role == 2
              ? "Register"
              : item?.role == 3
                ? "Subscriber"
                : item?.role == 4
                  ? "Partner"
                  : item?.role == 5
                    ? "Partner"
                    : item?.role == 6
                      ? "Advertiser"
                      : item?.role == 7
                        ? "Multi User"
                        : item?.role == 8
                          ? "PPV User"
                          : item?.role == 9
                            ? "Guest"
                            : "";
        const statusText = item?.active == 1 ? "ACTIVE" : "INACTIVE";
        return {
          ...item,
          role: Role,
          active: statusText,
          // Preserve backend fields if they exist
          watch_hours: item.watch_hours,
          subscription_display_status: item.subscription_display_status
        };
      });
      setApiData(FilterHelp);
      setFilteredData(FilterHelp);
      setTotal(paginationData);
      setChartData((prev) => ({
        ...prev,
        categories: response?.data?.monthly_revenue_months,
        series: [
          {
            name: "USERS",
            data: response?.data?.monthly_revenue_counts,
          }
        ],
      }))
      setDefaultData((prev) => ({
        ...prev,
        totalSubscriber: response?.total_subscribed || 0,
        totalRegister: response?.total_registered || 0,
        totalAdmin: response?.total_admin || 0,
        totalPPVUser: response?.total_ppv || 0
      }))
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchRoleData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/account-types`, { headers: userAccessToken });
      const userRoles = response?.data?.UserRoles;
      setDefaultData((prev) => ({
        ...prev,
        roles: userRoles
      }))
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchFilterTypeData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/filter-types`, { headers: userAccessToken });
      const types = response?.data?.FilterTypes;
      setDefaultData((prev) => ({
        ...prev,
        filterTypes: types
      }))
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  // Fetch Player Analytics Data
  const fetchPlayerAnalyticsData = async () => {
    try {
      const headers = {
        'X-API-Key': apiKey,
        ...(tenantId ? { 'X-Tenant-ID': tenantId } : {}),
        'Content-Type': 'application/json'
      };
      const params = {
        startDate: editUser?.startDate,
        endDate: editUser?.endDate,
        filterType: editUser?.filterType,
        userRole: editUser?.role // Pass the selected role filter
      };
      const res = await axios.get(`${analyticsEndpoint}/summary`, { headers, params });
      if (res?.data) {
        setPlayerAnalytics({
          totalSessions: res.data.totalSessions || 0,
          totalWatchHours: res.data.totalWatchHours || 0,
          playCount: res.data.playCount || 0,
          pauseCount: res.data.pauseCount || 0
        });
      }
    } catch (err) {
      console.error('Error fetching player analytics:', err);
    }
  };

  const fetchFilterRoleData = async () => {

    setLoading(true)
    const requiredData = {
      role: editUser?.role
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/users-role-filter-analytics`, JSON.stringify(requiredData), { headers: userAccessToken });
      const userData = response?.data?.Users;
      const FilterHelp = userData.map((item) => {
        const Role =
          item?.role == 1
            ? "Admin"
            : item?.role == 2
              ? "Register"
              : item?.role == 3
                ? "Subscriber"
                : item?.role == 4
                  ? "Partner"
                  : item?.role == 5
                    ? "Partner"
                    : item?.role == 6
                      ? "Advertiser"
                      : item?.role == 7
                        ? "Multi User"
                        : item?.role == 8
                          ? "PPV User"
                          : item?.role == 9
                            ? "Guest"
                            : "";
        const statusText = item?.active == 1 ? "ACTIVE" : item?.active == 0 ? "INACTIVE" : "PENDING";
        return {
          ...item,
          role: Role,
          active: statusText,
          watch_hours: item.watch_hours,
          subscription_display_status: item.subscription_display_status
        };
      });
      setApiData(FilterHelp);
      setFilteredData(FilterHelp);
      setChartData((prev) => ({
        categories: response?.data?.monthly_revenue_months,
        series: [
          {
            name: editUser?.role == 1 ? "ADMIN" : editUser?.role == 2 ? "REGISTER" : editUser?.role == 3 && "SUBSCRIBER",
            data: response?.data?.monthly_revenue_counts,
          }
        ],
      }))
      setDefaultData((prev) => ({
        ...prev,
        totalSubscriber: response?.data?.total_subscribed || 0,
        totalRegister: response?.data?.total_registered || 0,
        totalAdmin: response?.data?.total_admin || 0,
        totalPPVUser: response?.data?.total_ppv || 0
      }))
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchFilterRoleAndDateData = async () => {
    setLoading(true)
    const requiredData = {
      role: editUser?.role,
      start_date: editUser?.startDate,
      end_date: editUser?.endDate
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/users-date-filter-analytics`, JSON.stringify(requiredData), { headers: userAccessToken });
      const userData = response?.data?.Users;
      const FilterHelp = userData.map((item) => {
        const Role =
          item?.role == 1
            ? "Admin"
            : item?.role == 2
              ? "Register"
              : item?.role == 3
                ? "Subscriber"
                : item?.role == 4
                  ? "Partner"
                  : item?.role == 5
                    ? "Partner"
                    : item?.role == 6
                      ? "Advertiser"
                      : item?.role == 7
                        ? "Multi User"
                        : item?.role == 8
                          ? "PPV User"
                          : item?.role == 9
                            ? "Guest"
                            : "";
        const statusText = item?.active == 1 ? "ACTIVE" : item?.active == 0 ? "INACTIVE" : "PENDING";
        return {
          ...item,
          role: Role,
          active: statusText,
          watch_hours: item.watch_hours,
          subscription_display_status: item.subscription_display_status
        };
      });
      setApiData(FilterHelp);
      setFilteredData(FilterHelp);
      setChartData((prev) => ({
        categories: response?.data?.monthly_revenue_months,
        series: [
          {
            name: editUser?.role == 1 ? "ADMIN" : editUser?.role == 2 ? "REGISTER" : editUser?.role == 3 && "SUBSCRIBER",
            data: response?.data?.monthly_revenue_counts,
          }
        ],
      }))
      setDefaultData((prev) => ({
        ...prev,
        totalSubscriber: response?.data?.total_subscribed || 0,
        totalRegister: response?.data?.total_registered || 0,
        totalAdmin: response?.data?.total_admin || 0,
        totalPPVUser: response?.data?.total_ppv || 0
      }))
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchFilterRoleAndDurationData = async () => {
    setLoading(true)
    const requiredData = {
      role: editUser?.role,
      filter_type: editUser?.filterType,
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/users-filter-analytics`, JSON.stringify(requiredData), { headers: userAccessToken });
      const userData = response?.data?.Users;
      const FilterHelp = userData.map((item) => {
        const Role =
          item?.role == 1
            ? "Admin"
            : item?.role == 2
              ? "Register"
              : item?.role == 3
                ? "Subscriber"
                : item?.role == 4
                  ? "Partner"
                  : item?.role == 5
                    ? "Partner"
                    : item?.role == 6
                      ? "Partner"
                      : item?.role == 7
                        ? "Multi User"
                        : item?.role == 8
                          ? "PPV User"
                          : item?.role == 9
                            ? "Guest"
                            : "";
        const statusText = item?.active == 1 ? "ACTIVE" : item?.active == 0 ? "INACTIVE" : "PENDING";
        return {
          ...item,
          role: Role,
          active: statusText,
          watch_hours: item.watch_hours,
          subscription_display_status: item.subscription_display_status
        };
      });
      setApiData(FilterHelp);
      setFilteredData(FilterHelp);
      setChartData((prev) => ({
        categories: response?.data?.monthly_revenue_months,
        series: [
          {
            name: editUser?.role == 1 ? "ADMIN" : editUser?.role == 2 ? "REGISTER" : editUser?.role == 3 && "SUBSCRIBER",
            data: response?.data?.monthly_revenue_counts,
          }
        ],
      }))
      setDefaultData((prev) => ({
        ...prev,
        totalSubscriber: response?.data?.total_subscribed || 0,
        totalRegister: response?.data?.total_registered || 0,
        totalAdmin: response?.data?.total_admin || 0,
        totalPPVUser: response?.data?.total_ppv || 0
      }))
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const currentMonthGet = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const firstDay = new Date(year, month - 1, 1).toISOString().split('T')[0];
    const lastDay = new Date(year, month, 0).toISOString().split('T')[0];
    setEditUser((prev) => ({
      prev,
      startDate: firstDay,
      endDate: lastDay
    }))
  }

  useEffect(async () => {
    fetchData();
  }, [withOutRefresh, page, limit, searchText]);


  useEffect(async () => {
    fetchData();
    fetchRoleData();
    fetchFilterTypeData();
    fetchPlayerAnalyticsData();
    // currentMonthGet()
  }, [withOutRefresh]);

  useEffect(() => {
    if (editUser?.role && editUser?.startDate && editUser?.endDate) {
      fetchFilterRoleAndDateData();
      fetchPlayerAnalyticsData();
    }
    else if (editUser?.role && editUser?.filterType) {
      fetchFilterRoleAndDurationData();
      fetchPlayerAnalyticsData();
    }
    else if (editUser?.role) {
      fetchFilterRoleData();
      fetchPlayerAnalyticsData();
    }
    else {
      fetchData();
      fetchPlayerAnalyticsData();
    }
  }, [editUser])

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const handleSort = (field) => {
    const sortedData = [...filteredData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setFilteredData(sortedData);
  };

  const roleOptions = defaultData?.roles
    ?.filter((item) => [1, 2, 3].includes(item?.id))
    ?.map((item) => ({
      value: item?.id,
      label: item?.role_name,
    })) || [];

  const multiSelectStyle = {
    control: (styles) => ({
      ...styles,
      minHeight: "20px",
      maxHeight: "80px",
      minWidth: "230px",
      maxWidth: "400px",
      flexWrap: "wrap",
      overflow: "hidden",
      border: "none",
      boxShadow: "none",
      borderRadius: "10px",
    }),

    valueContainer: (styles) => ({
      ...styles,
      display: "flex",
      flexWrap: "wrap",
      maxHeight: "70px",
      overflowY: "auto",
      scrollbarWidth: "thin",
    }),
  };

  return (
    <>
      <div className={`d-flex align-items-center flex-wrap px-md-0 px-3 pb-3 `}>
        <div className="col-sm-6 col-12">
          <h4 className="admin-title mb-0 theme-text-color text-md-start "> <MessageBox text={'Users Analytics'} /></h4>
        </div>
      </div>

      {/* Player Analytics Summary Cards for All Users */}

      <div className="row g-4 mb-3">
        {/* Registered Users */}
        <div className="col-md-4 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-primary-subtle text-primary me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <IconRegister styled={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{defaultData?.totalRegister || 0}</div>
              <div className="text-muted small">Registered Users</div>
            </div>
          </div>
        </div>

        {/* Subscribed Users */}
        <div className="col-md-4 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-success-subtle text-success me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <IconSubscriber styled={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{defaultData?.totalSubscriber || 0}</div>
              <div className="text-muted small">Subscribed Users</div>
            </div>
          </div>
        </div>

        {/* Admin Users */}
        <div className="col-md-4 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-warning-subtle text-warning me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <IconAdmin styled={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{defaultData?.totalAdmin || 0}</div>
              <div className="text-muted small">Admin Users</div>
            </div>
          </div>
        </div>
      </div>


      <div className="row g-4 mb-3">
        <div className="col-md-3 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-primary-subtle text-primary me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <FaEye style={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{playerAnalytics?.totalSessions || 0}</div>
              <div className="text-muted small">Total Sessions</div>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-success-subtle text-success me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <FaClock style={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{Number(playerAnalytics?.totalWatchHours || 0).toFixed(1)}h</div>
              <div className="text-muted small">User Watch Hours</div>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-info-subtle text-info me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <FaPlay style={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{playerAnalytics?.playCount || 0}</div>
              <div className="text-muted small">Play Events</div>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
            <div className="icon-circle bg-warning-subtle text-warning me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
              <FaPause style={{ width: "20px", height: "20px" }} />
            </div>
            <div>
              <div className="fs-4 fw-bold mb-1">{playerAnalytics?.pauseCount || 0}</div>
              <div className="text-muted small">Pause Events</div>
            </div>
          </div>
        </div>
      </div>


      <div className="theme-bg-color p-3 mb-3 rounded-2">
        <div className="d-flex align-items-center p-3 flex-wrap">
          {/* <div className="col-3">
            <div className="d-flex align-items-center gap-3 mb-3 justify-content-between totalResult">
              <MessageBox text="Registered User" /><p>{defaultData?.totalRegister?.length}</p>
            </div>
            <div className="d-flex align-items-center gap-3 mb-3 justify-content-between totalResult">
              <MessageBox text="Subscribed User" /><p>{defaultData?.totalSubscriber?.length}</p>
            </div>
            <div className="d-flex align-items-center gap-3 mb-3 justify-content-between totalResult">
              <MessageBox text="Admin User" /><p>{defaultData?.totalAdmin?.length}</p>
            </div>
            <div className="d-flex align-items-center gap-3 mb-3 justify-content-between totalResult">
              <MessageBox text="PPV User" /><p>{defaultData?.totalPPVUser?.length}</p>
            </div>
          </div> */}
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="position-relative">
                <IconFilter styled={{ width: "18px", height: "18px", className: "position-absolute filterIcon" }} />
                {/*Change in phase 2*/}
                <Select components={{ DropdownIndicator: () => null }} ref={roleRef} classNamePrefix="react-select" className="roleSelectCustom rounded-5 border border-1 theme-border-color theme-text-color" options={roleOptions} isMulti={true} isClearable={true} placeholder="Select Role" value={roleOptions?.filter((opt) => (editUser?.role || []).includes(opt.value))} onChange={(selectedOptions) => { const values = selectedOptions?.map((opt) => opt.value) || []; setEditUser((prev) => ({ ...prev, role: values })); }} styles={multiSelectStyle} />
              </div>
              <div className="d-flex align-items-center justify-content-between gap-3">
                {/* {editUser?.filterType === 'Last_Month' && ( */}
                <>
                  <div className="position-relative">
                    <input type="date" name="startDate" value={editUser?.startDate || ''} max={editUser?.endDate || new Date().toISOString().split('T')[0]} onChange={handleInput} ref={startDateRef} className="filterTypeCustom calender rounded-5 theme-text-color border border-1 theme-border-color " />
                  </div>
                  <div className="position-relative">
                    <input type="date" name="endDate" value={editUser?.endDate || ''} min={editUser?.startDate || ''} max={new Date().toISOString().split('T')[0]} onChange={handleInput} ref={endDateRef} className="filterTypeCustom calender rounded-5  theme-text-color border border-1 theme-border-color " />
                  </div>
                </>
                {/* )} */}
                <div className="position-relative">
                  <IconFilter styled={{ width: "18px", height: "18px", className: "position-absolute filterIcon" }} />
                  <select name="filterType" value={editUser?.filterType || ''} onChange={handleInput} className="filterTypeCustom rounded-5   border border-1 theme-border-color  theme-text-color" ref={filterTypeRef}>
                    <option value='' className="theme-bg-color theme-text-color" >Filter</option>
                    {defaultData?.filterTypes?.map((item, index) => {
                      return <option key={item?.filter_type} value={item?.filter_type} className="theme-bg-color theme-text-color">{item?.name}</option>
                    })}
                  </select>
                </div>
              </div>
            </div>
            <ApexUserAreaChart users={apiData ? apiData : []} chartData={chartData ? chartData : []} />
          </div>
        </div>
        {/* <div className="d-flex align-items-center pb-3">
          <div className="col-3">
            <select name="role" value={editUser?.role} onChange={handleInput} className="form-select  custom-placeholder   border border-1 theme-border-color  theme-text-color" ref={roleRef}>
              <option value='' className="theme-bg-color theme-text-color" >Select Role</option>
              {defaultData?.roles?.filter((item) => [1, 2, 3].includes(item?.id))?.map((item, index) => {
                return <option key={item?.id} value={item?.id} className="theme-bg-color theme-text-color">{item?.role_name}</option>
              })}
            </select>
          </div>
          <div className="col-9 px-4 d-flex align-items-center justify-content-end">
            <div className="col-3 pe-2">
              <input type="date" name="startDate" value={editUser?.startDate || ''} max={editUser?.endDate || ''} onChange={handleInput} ref={startDateRef} className="rs-input py-3 px-3 custom-placeholder theme-text-color border border-1 theme-border-color " />
            </div>
            <div className="col-3 pe-2">
              <input type="date" name="endDate" value={editUser?.endDate || ''} min={editUser?.startDate || ''} onChange={handleInput} ref={endDateRef} className="rs-input py-3 px-3 custom-placeholder theme-text-color border border-1 theme-border-color " />
            </div>
            <div className="col-3 d-flex align-items-center">
              <p className="d-inline m-0 px-2">OR</p>
              <select name="filterType" value={editUser?.filterType || ''} onChange={handleInput} className="form-select custom-placeholder   border border-1 theme-border-color  theme-text-color" ref={filterTypeRef}>
                <option value='' className="theme-bg-color theme-text-color" >Select Filter Type</option>
                {defaultData?.filterTypes?.map((item, index) => {
                  return <option key={item?.filter_type} value={item?.filter_type} className="theme-bg-color theme-text-color">{item?.name}</option>
                })}
              </select>
            </div>
          </div>
        </div> */}
      </div>
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable" >
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
          <div className="position-relative" style={{ maxWidth: '300px' }}>
            <input
              type='text'
              placeholder="Search"
              className="filter form-control theme-text-color theme-border-secondary theme-bg-color-secondary"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ paddingRight: searchText ? '35px' : '12px' }}
            />
            {searchText && (
              <button
                type="button"
                onClick={() => setSearchText('')}
                className="btn btn-link position-absolute top-50 end-0 translate-middle-y p-0 me-2"
                style={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontSize: '18px',
                  lineHeight: 1,
                  color: '#6c757d',
                  textDecoration: 'none'
                }}
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </div>
          <AdminHeader hideExport hideSearch reduceData={filteredData} originalData={apiData} fileName={'USER-LIST'} customUser reloadAction={handleReload} reload loading={loading} />
        </div>
        <AdminTable
          data={filteredData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          onSort={handleSort}
          viewType={formData?.view_type}
          className="no-border-table theme-text-color "
        />


      </div >

      {/* Watch History Modal */}
      <Modal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        size="xl"
        centered
        contentClassName="theme-bg-color border-0 theme-text-color p-3"
      >
        <Modal.Header closeButton closeVariant="dark" className="border-bottom theme-border-color">
          <Modal.Title className="">
            Watch History
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="row mb-4 g-3">
            <div className="col-md-3">
              <div className="p-3 rounded-3 theme-bg-color border theme-border-color">
                <div className="small text-muted mb-1">User Name</div>
                <div className="fw-bold">{selectedUser?.name || selectedUser?.username || '-'}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3 rounded-3 theme-bg-color border theme-border-color">
                <div className="small text-muted mb-1">User Email</div>
                <div className="fw-bold">{selectedUser?.email || '-'}</div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="p-3 rounded-3 theme-bg-color border theme-border-color">
                <div className="small text-muted mb-1">User ID</div>
                <div className="fw-bold">{selectedUser?.id || '-'}</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-3 rounded-3 theme-bg-color border theme-border-color">
                <div className="small text-muted mb-1">Total Watch Hours</div>
                <div className="fw-bold text-primary">{selectedUser?.watch_hours || '00:00:00'}</div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Watched Videos Breakdown</h6>
            <div className="position-relative" style={{ maxWidth: '250px' }}>
              <input
                type='text'
                placeholder="Search..."
                className="form-control form-control-sm theme-text-color theme-border-secondary theme-bg-color-secondary"
                value={modalSearchText}
                onChange={(e) => setModalSearchText(e.target.value)}
                style={{ paddingRight: modalSearchText ? '60px' : '60px' }}
              />
              {modalSearchText && (
                <button
                  type="button"
                  onClick={() => setModalSearchText('')}
                  className="btn btn-link position-absolute top-50 end-0 translate-middle-y p-0 me-2"
                  style={{
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    fontSize: '16px',
                    lineHeight: 1,
                    color: '#6c757d',
                    textDecoration: 'none'
                  }}
                >
                  ×
                </button>
              )}
            </div>
          </div>
          <div className="table-responsive rounded-3 border theme-border-color modal-table-container">
            <Table hover className="mb-0 no-border-table">
              <thead>
                <tr className="theme-bg-color border-bottom theme-border-color">
                  <th className="py-3 px-3">Video Title</th>
                  <th className="py-3 px-3">Category</th>
                  <th className="py-3 px-3">Device</th>
                  <th className="py-3 px-3">Date</th>
                  <th className="py-3 px-3 text-center">Hours Watched</th>
                </tr>
              </thead>
              <tbody>
                {modalLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <Spinner animation="border" variant="primary" size="sm" className="me-2" />
                      Loading History...
                    </td>
                  </tr>
                ) : watchHistory?.filter(item =>
                  item.video_title?.toLowerCase().includes(modalSearchText.toLowerCase()) ||
                  item.video_id?.toString().includes(modalSearchText)
                ).length > 0 ? (
                  watchHistory
                    ?.filter(item =>
                      item.video_title?.toLowerCase().includes(modalSearchText.toLowerCase()) ||
                      item.video_id?.toString().includes(modalSearchText)
                    )
                    .map((item, index) => (
                      <tr key={index} className="border-bottom theme-border-color align-middle">
                        <td className="py-3 px-3">
                          <div className="fw-medium" title={item.video_title}>
                            {item.video_title?.length > 25 ? `${item.video_title.substring(0, 25)}...` : item.video_title}
                          </div>
                          <div className="small text-muted">ID: {item.video_id}</div>
                        </td>
                        <td className="py-3 px-3">
                          <span className="badge bg-secondary-subtle text-secondary border">{item.video_source || 'Video'}</span>
                        </td>
                        <td className="py-3 px-3">
                          <div className="small text-truncate" style={{ maxWidth: '150px' }} title={item.device_name}>
                            {item.device_name || '-'}
                          </div>
                        </td>
                        <td className="py-3 px-3">
                          <div className="small text-nowrap">
                            {item.last_watched ? moment(item.last_watched).format('DD-MM-YYYY HH:mm') : '-'}
                          </div>
                        </td>
                        <td className="py-3 px-3 text-center fw-bold text-primary">
                          {item.watch_hours}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5 text-muted">
                      {modalSearchText ? "No matching videos found." : "No watch history found for this user."}
                    </td>
                  </tr>
                )}

              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top theme-border-color">
          <Button variant="outline-light" onClick={() => setShowHistoryModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UsersAnalytics;
